import React from "react";

export default function OperationsManagerComponent() {
  return (
    <div
      className="main_contact_area app pt-40 bg_fixed"
     
    >
      <div className="container">
        <div className="row align-items-center">
          {/* Left Side Image */}
          <div class="col-lg-8 pb-180">  
          <div className="section_main_title black text-left">
                <h5>Responsibilities</h5>
          </div>      
            <div class="why-choose-icon " data-wow-delay=".5">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Oversee daily Ops team operations, ensuring efficiency and GDPR compliances.</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".6">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Ensure the accuracy, quality, and completeness of data collected, maintained and 
                delivered by the teams. </h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Able to communicate effectively with the clients globally and tackle their queries. </h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Effectively communicate with global stakeholders, presenting performance reports & strategic recommendations.</h6>
              </div>
             
            </div>
            
           
            <div className="section_main_title black text-left mt-3">
                <h5>Requirements</h5>
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Strong leadership, people and project management skills, with the ability to 
                motivate and develop team members.</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Proven experience in leading teams and delivering excellent results. </h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Strong proficiency in data and other analytics tools. </h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Strong communication and interpersonal skills, with the ability to interact effectively 
                with stakeholders at all levels. </h6>
              </div>
             
            </div>
          

            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Knowledge of data protection regulations (e.g., GDPR) and industry best practices.</h6>
              </div>
             
            </div>

            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Ability to work in a fast-paced environment and manage multiple priorities. </h6>
              </div>
             
            </div>







     
 
</div>


          {/* Right Side Contact Form */}
          <div className="col-lg-4">
            <div className="section_title black mb-4">
             
              <div className="section_main_title">
                <h1>Apply Now</h1>
              </div>
            </div>

         
            <iframe
              id="if15on87"
              src="https://formnx.com/f/career-15on87?iframe=true"
              frameBorder="0"
              style={{ width: '1px', minWidth: '100%', height: '700px' }}
              title="Career Form"
            />
            <script src="https://formnx.com/js/iframeResizer.js"></script>
            <script src="https://formnx.com/js/widget.js"></script>
          </div>
        </div>
      </div>
    </div>
  );
}
